<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-form :inline="true">
          <el-form-item style="margin-right: 20px">
            <el-select
              v-model="departmentId"
              placeholder="请选择部门"
              style="width: 200px"
              size="small"
              filterable
              clearable
              @change="search"
              @clear="search"
            >
              <el-option
                v-for="item in departments"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item style="margin-right: 20px">
            <el-date-picker
              v-model="rqScope"
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              @change="onDateChange"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="search"
              size="small"
              >搜索</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="showAdvanceSearchVisible = !showAdvanceSearchVisible"
            >
              <i
                :class="
                  showAdvanceSearchVisible
                    ? 'fa fa-angle-double-up'
                    : 'fa fa-angle-double-down'
                "
                aria-hidden="true"
              ></i>
              高级搜索
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 右边工具 -->
      <div>
        <el-button
          type="primary"
          icon="el-icon-edit-outline"
          @click="batchRecheck"
          size="small"
          v-if="qx"
          >批量复核</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="showAddView"
          size="small"
          v-if="qx"
          >添加费用</el-button
        >
      </div>
      <!--
			 <el-button type="success" disabled="true" size="small"> <i class="fa fa-level-up" aria-hidden="true"></i> 导入数据
							</el-button>
							<el-button type="success" disabled="true" size="small"> <i class="fa fa-level-down" aria-hidden="true"></i> 导出数据
							</el-button>
							-->
    </div>

    <!-- 高级搜索（参照"商机管理"页面） -->
    <transition name="slide-fade">
      <div
        v-show="showAdvanceSearchVisible"
        style="
          border: 1px solid #409eff;
          border-radius: 5px;
          box-sizing: border-box;
          padding: 5px;
          margin: 10px 0px;
        "
      >
        <!-- 字段布局参照"商机管理"页面：el-row + el-col 栅格（span 4 / 8 / 4） -->
        <el-row style="margin-top: 5px; margin-bottom: 5px">
          <el-col :span="4">
            <el-input
              style="width: 130px"
              prefix-icon="el-icon-edit"
              v-model="costName"
              size="mini"
              placeholder="费用名称"
              clearable
            >
            </el-input>
          </el-col>

          <el-col :span="8">
            <el-input
              style="width: 140px; margin-right: 10px"
              prefix-icon="el-icon-edit"
              v-model.number="cost1"
              size="mini"
              placeholder="最小费用金额"
              clearable
            >
            </el-input>
            <el-input
              style="width: 140px; margin-right: 10px"
              prefix-icon="el-icon-edit"
              v-model.number="cost2"
              size="mini"
              placeholder="最大费用金额"
              clearable
            >
            </el-input>
          </el-col>

          <el-col :span="4">
            <el-input
              style="width: 130px"
              prefix-icon="el-icon-edit"
              v-model="bz"
              size="mini"
              placeholder="请输入备注信息"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px; margin-bottom: 5px">
          <el-col :span="8">
            <el-button size="mini" @click="clearAdvanceSearch">取消</el-button>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-search"
              @click="search"
              >搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
    </transition>
    <!-- 表格 -->
    <div>
      <el-table
        class="el-table"
        :data="costData"
        stripe
        :cell-class-name="cellClassName"
        border
        :row-style="{ height: '59px' }"
        height="calc(100vh - 280px)"
        :cell-style="{ padding: '5px 0' }"
        size="small"
        fit
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- 多选框 -->
        <el-table-column type="selection" align="center" :selectable="selectable" width="55"></el-table-column>
        <el-table-column
          prop="departmentId"
          label="部门ID"
          fixed
          align="center"
          width="90"
        >
        </el-table-column>
        <el-table-column
          prop="departmentName"
          label="部门名称"
          fixed
          align="center"
        >
        </el-table-column>
        <el-table-column prop="rq" label="费用日期" align="center" width="120">
        </el-table-column>
        <el-table-column prop="costName" label="费用名称" align="center">
        </el-table-column>
        <el-table-column label="费用金额" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.cost) }}元</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="费用金额"  align="center"  width="130">
					<template slot-scope="scope">
						<span v-if="scope.row.cost<10000">{{scope.row.cost}}</span> <span style="font-size: 10px"
							v-if="scope.row.cost<10000">元</span>
						<el-tag v-if="scope.row.cost>=10000">{{scope.row.cost/10000}}</el-tag> <span
							style="font-size: 10px" v-if="scope.row.cost>=10000">万元</span>
					</template>
				</el-table-column> -->
        <el-table-column prop="bz" label="备注信息" align="center">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="录入人员"
          sortable
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="checkUserName"
          label="复核人员"
          sortable
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.isCheck === '1' ? scope.row.checkUserName : '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建日期"
          align="center"
        
        min-width="130"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="修改日期"
          align="center"
        
        min-width="130"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="250"
          v-if="qx"
        >
          <template slot-scope="scope">

            <template v-if="needReCheck(scope.row)">
              <el-button type="primary" size="mini" v-if="scope.row.isCheck === '0'" @click="reCheck(scope.row.id, 1)">
                复核
              </el-button>
              <el-button type="warning" size="mini" v-else @click="reCheck(scope.row.id, 0)">
                撤销复核
              </el-button>
            </template>
            <!-- <el-button type="primary" size="mini" style="padding: 2px">编辑</el-button> -->
            <el-button
              type="primary"
              size="mini"
              @click="showEditView(scope.row)"
              :disabled="kaiguan(scope.row.createTime) || scope.row.isCheck === '1'"
              >编辑</el-button
            >
            <el-button
              type="danger"
              @click="deleteRecord(scope.row)"
              size="mini"
              :disabled="kaiguan(scope.row.createTime) || scope.row.isCheck === '1'"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="display: flex; justify-content: space-between; margin-top: 5px">

        <div>费用总金额: {{ feeTotal }}元</div>
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>
    <!-- 弹出框  dialogVisible:是否弹出 添加或编辑-->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="70%"       :close-on-click-modal="false"
      :close-on-press-escape="false"
>
      <div>
        <!-- 增加一层 el-form表单，可以数据校验 -->
        <el-form ref="inputForm" :model="inputObj" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="部门名称" prop="departmentId">
                <el-select
                  v-model="inputObj.departmentId"
                  placeholder="请选择"
                  size="mini"
                  :disabled="xmShow"
                  style="width: 250px"
                >
                  <el-option
                    v-for="item in departments"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="费用日期" prop="rq">
                <el-date-picker
                  size="mini"
                  v-model="inputObj.rq"
                  style="width: 250px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="费用名称" prop="costCode">
                <el-select
                  v-model="inputObj.costCode"
                  placeholder="请选择"
                  size="mini"
                  style="width: 250px"
                >
                  <el-option
                    v-for="item in costCodes"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="  费用金额" prop="cost">
                <el-input
                  type="number"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 250px"
                  v-model="inputObj.cost"
                  placeholder="请输入金额,单位(元)"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="备注信息" prop="cost">
                <el-input
                  type="text"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 770px"
                  v-model="inputObj.bz"
                  placeholder="请输入备注信息"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doChance">取 消</el-button>
        <el-button type="primary" @click="doAddRecord">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { batCheckCost } from "@/api/depa/index";
import { kz90 } from "../../utils/MyFunction";
export default {
  name: "DepaList",
  data() {
    return {
      multipleSelection: [], // 选择的多条数据
      qx: true, // 总经理、销售总监编辑的权限
      title: "",
      xmShow: false,
      costData: [], // 存放查询结果
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      departmentId: null,

      costName: "",
      cost1: "",
      cost2: "",
      bz: "",
      rqScope: [], // 费用日期区间（绑定日期控件，提交时拆成 rqBegin/rqEnd）
      queryRqBegin: "", // 查询用：费用日期起
      queryRqEnd: "", // 查询用：费用日期止
      showAdvanceSearchVisible: false, // 高级搜索面板显隐

      dialogVisible: false,
      // 新增费用对象
      inputObj: {
        id: null,
        departmentId: null,
        rq: "",
        costCode: "",
        cost: null,
        bz: null,
      },
      departments: [], //部门id-部门名称下拉框
      costCodes: [], // 费用 下拉框
      rules: {
        departmentId: [
          {
            required: true,
            message: "请选择部门名称",
            trigger: "blur",
          },
        ],
        rq: [
          {
            required: true,
            message: "请选择费用日期",
            trigger: "blur",
          },
        ],
        costCode: [
          {
            required: true,
            message: "请选择费用代码",
            trigger: "blur",
          },
        ],
        cost: [
          {
            required: true,
            message: "请输入费用金额",
            trigger: "blur",
          },
        ],
      },
      userId: sessionStorage.getItem('uid')
    };
  },
  mounted() {
    this.quanxian();
    this.initCost();
    this.initDim();
  },
  computed: {
    // 费用总金额
    feeTotal(){
      let total = 0;
      this.costData.forEach(item => {
        total += Number(item.cost);
      });
      return total.toFixed(2);
      
  
    }
  },
  methods: {
    // 多选框选择变化
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    // 批量复核
    batchRecheck(){
      if(this.multipleSelection.length === 0){
        this.$message({
          type: 'warning',
          message: '请选择需要复核的费用记录'
        });
        return;
      }
      this.$confirm('是否进行批量复核', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = [];
        ids = this.multipleSelection.map(row => {
          return row.id; 
        })

        batCheckCost({ ids, isCheck: "1"}).then(res => {
          if(res.code === 200){
            this.initCost(1);
            this.$message({
              type: 'success',
              message: '批量复核成功'
            });
          }
        })
        
      })
    },
    selectable(row, index) {
      // 根据条件禁用复选框
      return this.needReCheck(row) && row.isCheck !== '1';
    },
    // 表格单元格样式
    cellClassName({ row, column }) {
        // if (column.type === 'selection' && (!this.needReCheck(row) || row.isCheck === '1')) {
        //   return 'hidden-row'
        // }
        return ''
    },
    // 是否需要操作
    needOperate(row){
      return !(row.costCode === "C018" && row.bz.includes('运输快递费(系统自动入库)'))  // 系统自动录入的运输快递费用不必操作
      && !(row.costCode === "C002" && row.bz.includes('办公打印费(系统自动入库)')) // 系统自动录入的办公打印费用不必操作
    },
    // 是否需要复核
    needReCheck(row){
      return this.userId != row.userId // 判断是否是本人录入,不是本人不能复核
      && !(row.costCode === "C014" && row.bz.includes('系统自动录入租车费用'))  // 系统自动录入的租车费用不必复核
      && !(row.costCode === "C022" && (row.bz.includes('系统自动录入还款费用') || row.bz.includes('系统自动录入借款费用'))) // 系统自动录入的还款费用不必复核
      && !(row.costCode === "C009" && row.bz.includes('系统自动录入租车费用'))
    },
    // 复核操作
    reCheck(id, isCheck){
      let tipText = (isCheck === 1 ? '是否复核此条录入信息?': '是否撤销复核?')
      this.$confirm(tipText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postRequest2('/depa/cost_check',{ id, isCheck }).then(res => {
          if(res.code === 200){
            this.initCost(1);
          }
        })
        
      })
    },
    moneyNumber(val) {
      return val.toLocaleString("zh-Hans-CN", {
        style: "currency",
        currency: "CNY",
      });
      // return val.toLocaleString()
    },
    quanxian() {
      if (!window.sessionStorage.getItem("userRoleId")) {
        //权限为空
        // 暂时不做处理，本来应该直接退出
      } else {
        if (window.sessionStorage.getItem("userRoleId") == 8) {
          this.qx = false;
        }
        if (window.sessionStorage.getItem("userRoleId") == 17) {
          this.qx = false;
        }
      }
    },
    kaiguan(sj) {
      var sf = kz90(sj);
      return sf;
    },
    doChance() {
      this.dialogVisible = false;
      this.initCost(1);
    },
    showEditView(data) {
      this.title = "编辑费用";
      this.dialogVisible = true;
      this.xmShow = true;
      this.inputObj = data;
    },
    deleteRecord(data) {
      // alert(JSON.stringify(data))
      this.$confirm(
        "此操作将永久删除 " + data.departmentName + "的该条费用明细, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.postRequest2("/depa/cost_delete?id=" + data.id).then((resp) => {
            if (resp) {
              this.initCost(1);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    doAddRecord() {
      // 添加 或 编辑
      if (this.inputObj.id) {
        // 编辑修改
        // alert(JSON.stringify(this.inputObj))
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/depa/cost_update", this.inputObj).then(
              (resp) => {
                if (resp) {
                  this.dialogVisible = false;
                  this.initCost(1);
                }
              }
            );
          }
        });
      } else {
        // 添加
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/depa/cost_add", this.inputObj).then((resp) => {
              if (resp) {
                this.dialogVisible = false;
                this.initCost(1);
              }
            });
          }
        });
      }
      // this.dialogVisible = false
    },
    initDim() {
      if (!window.sessionStorage.getItem("departments")) {
        this.postRequest("/dim/dim_table_char/department").then((resp) => {
          if (resp) {
            this.departments = resp.result;
            this.saveDictCache("departments", resp.result);
          }
        });
      } else {
        this.departments = this.dictCache("departments");
      }
      if (!window.sessionStorage.getItem("costCodes")) {
        this.postRequest("/dim/dim_table_char/costCode").then((resp) => {
          if (resp) {
            this.costCodes = resp.result;
            this.saveDictCache("costCodes", resp.result);
          }
        });
      } else {
        this.costCodes = this.dictCache("costCodes");
      }
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initCost(true);
    },
    sizeChange(limit) {
      this.limit = limit;
      this.page = 1;
      this.initCost(true);
    },
    // 条件查询：回到第 1 页再查，避免停留在超出结果范围的页码上
    search() {
      this.page = 1;
      this.initCost(true);
    },
    // 费用日期区间变化：拆成起止日期后查询
    onDateChange(val) {
      if (val && val.length === 2) {
        this.queryRqBegin = val[0];
        this.queryRqEnd = val[1];
      } else {
        this.queryRqBegin = "";
        this.queryRqEnd = "";
      }
      this.search();
    },
    // 高级搜索取消：清空高级条件（保留主搜索的部门与日期）后重新查询
    clearAdvanceSearch() {
      this.costName = "";
      this.cost1 = "";
      this.cost2 = "";
      this.bz = "";
      this.search();
    },
    showAddView() {
      this.title = "添加费用";
      this.dialogVisible = true;
      this.xmShow = false;
      this.inputObj = {
        id: null,
        projectId: null,
        rq: "",
        costCode: "",
        cost: null,
      };
    },
    initCost(tj) {
      var url = `/depa/cost_list?page=${this.page}&limit=${this.limit}`;
      if (tj) {
        url = url + "&departmentId=" + this.departmentId;
        url = url + "&costName=" + this.costName;
        url = url + "&cost1=" + this.cost1;
        url = url + "&cost2=" + this.cost2;
        url = url + "&bz=" + this.bz;
        // 费用日期区间
        if (this.queryRqBegin) url += "&rqBegin=" + this.queryRqBegin;
        if (this.queryRqEnd) url += "&rqEnd=" + this.queryRqEnd;
      }
      this.loading = true;
      this.getRequest(url).then((resp) => {
        this.loading = false;
        if (resp) {
          this.costData = resp.data;
          this.total = resp.count;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>


.el-table {
  ::v-deep .hidden-row .cell {
    display: none;
  }
}
</style>

<!-- 高级搜索淡入淡出动画（与"商机管理"页面一致；transition 需放在非 scoped 样式中） -->
<style>
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
